import SingleWatch from "../components/watches/single-watch/SingleWatch";
import Layout from "../layout/Layout";

const SingleWatchPage = () => {
  return (
    <Layout>
      <SingleWatch />
    </Layout>
  );
};

export default SingleWatchPage;
